<div class="home-layout container-fluid animate__animated animate__fadeIn">
  <div class="welcome-banner shadow-sm">
    <div class="d-flex align-items-center">
      <div class="icon-circle-lg me-3">
        <i class="bi bi-speedometer2"></i>
      </div>
      <div>
        <h2 class="fw-bold text-white mb-0">
          Bienvenido, {{ usuario() }}
        </h2>
      </div>
    </div>
  </div>

  <section class="home-section">
    <div class="section-heading">
      <div>
        <span class="section-eyebrow">Accesos principales</span>
        <h3>Operación del sistema</h3>
      </div>
    </div>
    <div class="primary-grid">
    @for (card of cards(); track card.titulo) {
        <article class="module-card"
          [class.module-card--clickable]="card.acciones.length === 1"
          [attr.role]="card.acciones.length === 1 ? 'link' : null"
          [attr.tabindex]="card.acciones.length === 1 ? 0 : null"
          (click)="openSingleActionCard(card)"
          (keydown)="handleCardKeydown($event, card)">
          <div class="module-card__accent bg-{{ card.color }}"></div>
          <div class="module-card__body">
            <div class="module-card__icon text-{{ card.color }}">
              <i class="bi {{ card.icono }} fs-3"></i>
            </div>
            <div class="module-card__content">
              <h4>{{ card.titulo }}</h4>
              <p>{{ card.descripcion }}</p>
            </div>
          </div>
          <div class="module-card__actions">
            @if (card.acciones.length > 1) {
              @for (accion of card.acciones; track accion.texto) {
                <a [routerLink]="accion.ruta" class="btn btn-{{ accion.estilo }} btn-sm">
                  <i class="bi {{ accion.icono }} me-1"></i>
                  {{ accion.texto }}
                </a>
              }
            }
          </div>
        </article>
    }
    </div>
  </section>

  @if (maintenanceActions().length) {
    <section class="home-section maintenance-section">
      <div class="section-heading">
        <div>
          <span class="section-eyebrow">Catálogos y configuración</span>
          <h3>Mantenimientos</h3>
        </div>
        <span class="section-count">{{ maintenanceActions().length }} opciones</span>
      </div>
      <div class="maintenance-grid">
        @for (action of maintenanceActions(); track action.ruta) {
          <a [routerLink]="action.ruta" class="maintenance-card">
            <span class="maintenance-card__icon">
              <i class="bi {{ action.icono }}"></i>
            </span>
            <span class="maintenance-card__content">
              <strong>{{ action.texto }}</strong>
              <small>Administrar registros</small>
            </span>
          </a>
        }
      </div>
    </section>
  }

  <footer class="footer-info">
    <i class="bi bi-info-circle me-1"></i>
    SIACI © {{currentYear}}
  </footer>
</div>
